export default __webpack_public_path__ + "static/media/010-helicopter.bb4f6c67.svg";